export const AUTH_USER_STORAGE_KEY = "openfarming.auth.user";

function canUseLocalStorage() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function getStoredUserString() {
  if (!canUseLocalStorage()) {
    return null;
  }

  return window.localStorage.getItem(AUTH_USER_STORAGE_KEY);
}

export function setStoredUserString(user: string | null) {
  if (!canUseLocalStorage()) {
    return;
  }

  if (user) {
    window.localStorage.setItem(AUTH_USER_STORAGE_KEY, user);
    return;
  }

  window.localStorage.removeItem(AUTH_USER_STORAGE_KEY);
}

export function hasStoredUser() {
  return getStoredUserString() !== null;
}

export function getStoredUserId() {
  const storedUser = getStoredUserString();

  if (!storedUser) {
    return undefined;
  }

  try {
    const parsedUser = JSON.parse(storedUser) as { id?: unknown };
    return typeof parsedUser.id === "number" ? parsedUser.id : undefined;
  } catch {
    return undefined;
  }
}
